<template>
  <section class="bg-primary-subdued mt-48 w-full">
    <div class="mx-auto max-w-736 px-16 pt-24 pb-48">
      <h2 class="text-h3">Info just for you</h2>
      <div class="overflow-x-scroll hide-scrollbar lg:overflow-x-visible pt-16 pb-32 px-4 lg:px-0">
        <ul class="flex gap-16 sm:gap-24">
          <li v-for="blog in blogCards" :key="blog.title" class="w-full hover:text-primary">
            <a :href="blog.linkUrl" class="primary-focus">
              <component :is="blog.imageComponent" class="mb-8 box-shadow-md rounded-xl" />
              <p class="text-strong-body">{{ blog.title }}</p>
            </a>
          </li>
        </ul>
      </div>
      <Button
        value="Get more info"
        variant="outlined"
        size="medium"
        class="!bg-primary-subdued w-full sm:w-auto"
        href="/sitters"
      />
    </div>
  </section>
</template>

<script lang="ts">
import Card from '../../../components/card/Card.vue';
import Button from '../../../components/button/Button.vue';
import JobAppTips from '../../../icons/JobAppTips.vue';
import MakeTheMostBlog from '../../../icons/MakeTheMostBlog.vue';
import RedFlags from '../../../icons/RedFlags.vue';

export default {
  name: 'InfoJustForYou',
  components: { Card, Button, JobAppTips, MakeTheMostBlog, RedFlags },
  computed: {
    blogCards(): any {
      return [
        {
          imageComponent: JobAppTips,
          title: 'Job Application Writing Tips',
          linkUrl: '/sitters/writing-a-winning-sitter-or-nanny-application',
        },
        {
          imageComponent: MakeTheMostBlog,
          title: 'Make the Most of Sittercity',
          linkUrl: '/sitters/how-to-use-babysitting-websites-as-a-sitter',
        },
        {
          imageComponent: RedFlags,
          title: 'Scammer Red Flags you should know',
          linkUrl: '/sitters/scammer-red-flags-you-should-know',
        },
      ];
    },
  },
};
</script>
